import { isAxiosError } from "axios";
export function getErrorMessage(error) {
    if (isAxiosError(error)) {
        return (error.userMessage ??
            error.response?.data?.message ??
            "서버 요청에 실패했습니다.");
    }
    if (error instanceof Error)
        return error.message;
    if (typeof error === "string")
        return error;
    return "알 수 없는 오류가 발생했습니다.";
}
